<template>
  <button :class="(this.customColor?this.customColor+' ':'')+'button button-primary'+(this.fullWidth?' full-width':'')"
          :disabled="!!this.disabled"
  >
    {{ text }}
  </button>
</template>

<style>
button.button-primary.green {
  background-color: var(--success);
  border-color: var(--success);
}
</style>

<style scoped>
.button-primary {
  background-color: var(--ink);
  border-color: var(--ink);
  color: white;
}

.button-primary:hover:not(:disabled) {
  background-color: var(--ink-hover);
  border-color: var(--ink-hover);
}
</style>

<script>
export default {
  props: [
    "text",
    "customColor",
    "disabled",
    "fullWidth",
  ],
}
</script>